var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusInCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66669 15C12.5327 15 15.6667 11.866 15.6667 8C15.6667 4.13401 12.5327 1 8.66669 1C4.80069 1 1.66669 4.13401 1.66669 8C1.66669 11.866 4.80069 15 8.66669 15ZM8.66669 4.5C9.05329 4.5 9.36669 4.8134 9.36669 5.2V7.3H11.4667C11.8533 7.3 12.1667 7.6134 12.1667 8C12.1667 8.3866 11.8533 8.7 11.4667 8.7H9.36669V10.8C9.36669 11.1866 9.05329 11.5 8.66669 11.5C8.28009 11.5 7.96669 11.1866 7.96669 10.8V8.7H5.86669C5.48009 8.7 5.16669 8.3866 5.16669 8C5.16669 7.6134 5.48009 7.3 5.86669 7.3H7.96669V5.2C7.96669 4.8134 8.28009 4.5 8.66669 4.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusInCircle);
export default __webpack_public_path__ + "static/media/plus-in-circle.0cd9aa31bc70e74984355f09ba04cfc8.svg";
export { ForwardRef as ReactComponent };